export const LOGIN_MODAL_POST = 'LOGIN_MODAL_POST';
export const LOGIN_MODAL_SHOW = 'LOGIN_MODAL_SHOW';
export const LOGIN_MODAL_CONTINUE_WITHOUT_LOGIN =
  'LOGIN_MODAL_CONTINUE_WITHOUT_LOGIN';
export const LOGIN_MODAL_RECEIVE = 'LOGIN_MODAL_RECEIVE';
export const LOGIN_MODAL_PREFFERED_ORG_ID = 'LOGIN_MODAL_PREFFERED_ORG_ID';
export const LOGIN_MODAL_ERROR = 'LOGIN_MODAL_ERROR';

export const LOGIN_MODAL_OPEN_ORGANIZATION_SELECTOR =
    'LOGIN_MODAL_OPEN_ORGANIZATION_SELECTOR';

export const GENERIC_LOADER_UPDATE =
  'GENERIC_LOADER_UPDATE';
export const
    GENERIC_DATA_VIEW_SET_SEARCH_PENDING_STATUS =
        'GENERIC_DATA_VIEW_SET_SEARCH_PENDING_STATUS';

export const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';

// 30MB
export const maxFileSizeToDownload = 30000000;
